@if (!exportMode) {
<div class="trainings__edit-button-div">
  @if (editMode) {
    <button
      mat-raised-button
      class="trainings__edit-btn trainings__edit-btn--text"
      (click)="onCancelEdit()"
      [disabled]='isCancelDisabled'
    >
      {{ 'general.cancel' | translate }}
    </button>

    <button
      mat-icon-button
      class="trainings__edit-btn trainings__edit-btn--icon"
      (click)="onCancelEdit()"
      [attr.aria-label]="'general.cancel' | translate"
    >
      <mat-icon>close</mat-icon>
    </button>
  }
  <button
    mat-flat-button
    class="trainings__edit-btn trainings__edit-btn--text"
    [disabled]="editMode && (!hasChanges() || form.invalid || isSaving)"
    (click)="onToggleEdit()"
  >
    {{ editMode ? ('general.save' | translate) : ('general.edit' | translate) }}
  </button>

  <button
    mat-icon-button
    class="trainings__edit-btn trainings__edit-btn--icon"
    [disabled]="editMode && (!hasChanges() || form.invalid || isSaving)"
    (click)="onToggleEdit()"
    [attr.aria-label]="(editMode ? ('general.save' | translate) : ('general.edit' | translate))"
  >
    <mat-icon>{{ editMode ? 'save' : 'edit' }}</mat-icon>
  </button>
</div>
}

<form [formGroup]="form">
  @if (schulungenFormArray.length > 0) {
    <div formArrayName="schulungen" class="trainings__wrapper">
      @for (group of schulungenFormArray.controls; track group; let idx = $index) {
        <mat-card class="trainings__card" [class.trainings__card--export]="exportMode && !twoPagerMode">
          @if (exportMode && !twoPagerMode) {
            <mat-checkbox
              [checked]="selectedExportIds.includes(group.value.uuid || idx.toString())"
              (change)="toggleExportSelection(group.value.uuid || idx.toString(), $event.checked)"
            ></mat-checkbox>
          }
          <div [formGroupName]="idx" class="trainings__content">
            <div class="trainings__field">
              @if (!editMode) {
                <div class="trainings__label-row">
                  <mat-label class="trainings__question">{{ 'trainings.timePeriod' | translate }}</mat-label>
                  <app-field-warning [finding]="entryFinding(idx, 'beginn')"></app-field-warning>
                </div>
                <p class="trainings__answer">{{ group.value.beginn | date: 'MM/yyyy' }}</p>
              } @else {
                <mat-form-field>
                  <mat-label class="trainings__question">{{ 'trainings.timePeriod' | translate }}</mat-label>
                  <input matInput [matDatepicker]="datepicker" formControlName="beginn"/>
                  <mat-datepicker-toggle matIconSuffix [for]="datepicker"></mat-datepicker-toggle>
                  <mat-datepicker #datepicker>
                    <mat-datepicker-actions>
                      <button mat-button matDatepickerCancel>{{ 'general.cancel' | translate }}</button>
                      <button mat-flat-button matDatepickerApply>{{ 'general.apply' | translate }}</button>
                    </mat-datepicker-actions>
                  </mat-datepicker>
                  @if (group.get('beginn')?.invalid) {
                    <mat-error>{{ 'general.errors.required' | translate }}</mat-error>
                  }
                </mat-form-field>
              }
            </div>

            <div class="trainings__field">
              @if (!editMode) {
                <div class="trainings__label-row">
                  <mat-label class="trainings__question">{{ 'trainings.trainingProvider' | translate }}</mat-label>
                  <app-field-warning [finding]="entryFinding(idx, 'schulungsanbieter')"></app-field-warning>
                </div>
                <p class="trainings__answer">{{ group.value.schulungsanbieter }}</p>
              } @else {
                <mat-form-field>
                  <mat-label class="trainings__question">{{ 'trainings.trainingProvider' | translate }}</mat-label>
                  <input matInput type="text" formControlName="schulungsanbieter" [maxlength]="LIMITS.SHORT_LABEL"/>
                  <mat-hint align="end">{{ (group.get('schulungsanbieter')?.value?.length || 0) }}/{{ LIMITS.SHORT_LABEL }}</mat-hint>
                  @if (group.get('schulungsanbieter')?.hasError('required')) {
                    <mat-error>{{ 'general.errors.required' | translate }}</mat-error>
                  }
                  @if (group.get('schulungsanbieter')?.hasError('maxlength')) {
                    <mat-error>{{ 'general.validation.maxLength' | translate: { max: LIMITS.SHORT_LABEL } }}</mat-error>
                  }
                </mat-form-field>
              }
            </div>

            <div class="trainings__field">
              @if (!editMode) {
                <div class="trainings__label-row">
                  <mat-label class="trainings__question">{{ 'trainings.trainingCourse' | translate }}</mat-label>
                  <app-field-warning [finding]="entryFinding(idx, 'lehrgang')"></app-field-warning>
                </div>
                <p class="trainings__answer">{{ group.value.lehrgang }}</p>
              } @else {
                <div class="trainings__form-wrapper">
                  <mat-form-field appearance="fill" class="trainings__form-field">
                    <mat-label class="trainings__question">{{ 'trainings.trainingCourse' | translate }}</mat-label>
                    <input
                      #searchInputTraining
                      type="text"
                      matInput
                      (keyup)="filterTrainings(searchInputTraining.value, idx)"
                      formControlName="lehrgang"
                      [maxlength]="LIMITS.SHORT_LABEL"
                      [matAutocomplete]="auto"
                      (blur)="validateCourseSelection(idx)"
                    />
                    <mat-autocomplete
                      #auto="matAutocomplete"
                      (optionSelected)="optionSelected($event, idx)"
                    >
                      @for (name of filteredTrainingCourses[idx]; track name) {
                        <mat-option [value]="name">
                          {{ name }}
                        </mat-option>
                      }
                    </mat-autocomplete>
                    <mat-hint align="end">{{ (group.get('lehrgang')?.value?.length || 0) }}/{{ LIMITS.SHORT_LABEL }}</mat-hint>
                    @if (group.get('lehrgang')?.hasError('required')) {
                      <mat-error>
                        {{ 'general.errors.required' | translate }}
                      </mat-error>
                    }
                    @if (group.get('lehrgang')?.hasError('maxlength')) {
                      <mat-error>{{ 'general.validation.maxLength' | translate: { max: LIMITS.SHORT_LABEL } }}</mat-error>
                    }
                  </mat-form-field>
                </div>
              }
              @if (editMode) {
                <div class="trainings__button-wrapper">
                  <button mat-flat-button (click)='onAddRequestClick()'>{{ 'trainings.expandTrainingList' | translate }}
                    <mat-icon>add</mat-icon>
                  </button>
                </div>
              }
            </div>

            <div class="trainings__field">
              <mat-label class="trainings__question">{{ 'trainings.export' | translate }}</mat-label>
              @if (!editMode) {
                <p>
                  {{
                    group.value.forExport
                      ? ('trainings.yes' | translate)
                      : ('trainings.no' | translate)
                  }}
                </p>
              } @else {
                <mat-checkbox
                  class="trainings__export-checkbox"
                  type="checkbox"
                  formControlName="forExport"
                ></mat-checkbox>
              }
            </div>

            <div class="trainings__field">
              @if (editMode && !group.value.uploadId) {
                <input
                  type="file"
                  accept=".pdf"
                  #fileInput
                  (change)="addAttachment($event, idx)"
                  hidden
                />
                <button
                  mat-raised-button
                  color="primary"
                  (click)="fileInput.click()"
                  class="trainings__upload-button"
                >
                  <mat-icon>upload</mat-icon>
                  {{ 'trainings.button.uploadTraining' | translate }}
                </button>
              } @else if (group.value.uploadId) {
                <div class="trainings__button-wrapper">
                  <button mat-button (click)="downloadSchulung(group.value.uploadId)" class="certificate__button">
                    <mat-icon>download</mat-icon>
                    {{ 'trainings.button.downloadTraining' | translate }}
                  </button>
                  @if (editMode) {
                    <button mat-button (click)="openDeleteAttachmentModal(idx)" class="certificate__button">
                      <mat-icon>delete</mat-icon>
                      {{ 'trainings.button.deleteTraining' | translate }}
                    </button>
                  }
                </div>
              }
            </div>

            @if (editMode) {
              <div class="trainings__save-button-div">
                <button
                  mat-mini-fab
                  color="primary"
                  (click)="openDeleteModal(idx)"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            }
          </div>
        </mat-card>
      }
    </div>

    @if (editMode) {
      <div class="trainings__add-button">
        <button mat-flat-button type="button" (click)="addSchulungForm()">
          <mat-icon>add</mat-icon>
          {{ 'trainings.button.createNewTraining' | translate }}
        </button>
      </div>
      @if (isPopupOpen) {
        <app-add-certificate
          (close)="isPopupOpen = false"
          (saved)="onTrainingSaved()"
          [type]="'trainings.type' | translate"
        ></app-add-certificate>
      }
    }
  } @else {
    <mat-card appearance="outlined" class="trainings__no-data">
      <mat-card-content>{{ 'trainings.noTrainings' | translate }}</mat-card-content>
    </mat-card>
  }
</form>

<!-- NP20-822: Bei vielen Einträgen ist der Weg nach oben weit; Abbrechen und Speichern
     kleben beim Bearbeiten am unteren Rand und rasten am Ende des Abschnitts ein. -->
@if (editMode && !exportMode) {
  <div class="sticky-save" role="group" [attr.aria-label]="'general.sectionActionsEnd' | translate">
    <button mat-stroked-button type="button" [disabled]="isCancelDisabled" (click)="onCancelEdit()">
      {{ 'general.cancel' | translate }}
    </button>
    <button mat-flat-button type="button" [disabled]="!hasChanges() || form.invalid || isSaving" (click)="onToggleEdit()">
      {{ 'general.save' | translate }}
    </button>
  </div>
}

<app-modal
  modalId="addTraining"
  [title]="'request.buttons.trainings'"
  [(visible)]="showModalAddRequest"
  [showButtons]="true"
  (save)="addTrainingRequest()"
  [showClose]="true"
  [contentTemplate]='trainingModal'
  [disabled]='addRequestFormInvalid'
  [saveText]="'request.modals.submit'"
></app-modal>

<ng-template #trainingModal>
  <div class='trainings__sub-header'>
    <mat-icon class='trainings__modal-icon'>
      warning
    </mat-icon>
    {{ 'request.modals.requestInfo' | translate }}
  </div>
  <form>
    <mat-form-field class="trainings__form-field">
      <mat-label>
        {{ 'request.modals.name'| translate }}
      </mat-label>
      <input
        matInput
        name="requests"
        [(ngModel)]="newReq.name"
        (ngModelChange)="onAddRequestFormChange()"
        [maxlength]="LIMITS.SHORT_LABEL"
        #requestsField="ngModel"
        required
      />
      @if (requestsField.hasError('required') && requestsField.touched) {
        <mat-error>
          {{
            'general.errors.required' | translate
          }}
        </mat-error>
      }
      @if (requestsField.hasError('maxlength')) {
        <mat-error>{{ 'general.validation.maxLength' | translate: { max: LIMITS.SHORT_LABEL } }}</mat-error>
      }
    </mat-form-field>
  </form>
</ng-template>


<app-modal
  modalId="deleteTrainings"
  [title]="'trainings.modal.title'"
  [text]="'trainings.modal.text'"
  [(visible)]="showModal"
  [showButtons]="true"
  (save)="delete(currentIdx)"
  [showClose]="true"
  [saveText]="'general.delete'"
></app-modal>

<app-modal
  modalId="deleteTrainingsAttachment"
  [title]="'trainings.modal.title'"
  [text]="'trainings.modal.textAttachment'"
  [(visible)]="showModalAttachment"
  [showButtons]="true"
  (save)="deleteAttachment(currentIdx)"
  [showClose]="true"
  [saveText]="'general.delete'"
></app-modal>
